export const routesAdmin = [
  {
    path: "/parametre",
    name: "parametre",
    component: () => import("@/views/parametre/index.vue"),
    meta: {
      public: false,
      title: "Parametre",
      yetki: { k: [], a: true },
    },
  },
  {
    path: "/laravel_log",
    name: "laravel_log",
    component: () => import("@/views/admin/LogViewer.vue"),
    meta: {
      public: false,
      title: "laravel log",
      yetki: { p: true },
    },
  },
  {
    path: "/faturalar",
    name: "faturalar",
    component: () => import("@/views/faturalar/index.vue"),
    meta: {
      public: false,
      title: "Faturalar",
      yetki: { k: [], a: true },
    },
  },
  {
    path: "/faturalarsube",
    name: "faturalarsube",
    component: () => import("@/views/faturalarsube/index.vue"),
    meta: {
      public: false,
      title: "Fatura-Şube",
      yetki: { k: [], a: true },
    },
  },
  {
    path: "/gelir",
    name: "gelir",
    component: () => import("@/views/gelir/index.vue"),
    meta: {
      public: false,
      title: "Gelir",
      yetki: { k: [], a: true },
    },
  },
  {
    path: "/eklentiler",
    name: "eklentiler",
    component: () => import("@/views/admin/Eklentiler.vue"),
    meta: {
      public: false,
      title: "Eklentiler",
      yetki: { p: true },
    },
  },
]
